import { connect } from "react-redux";

import { actions as modalSignupActions } from "./ModalSignup.redux";

import ModalSignup from "./ModalSignup.view";

const mapStateToProps = state => ({
  open: state.modalSignup.modalSignupOpen,
  targetDevice: state.targetDevice,
  useWebP: state.featureSupport.webpLossy,
});

const mapDispatchToProps = dispatch => ({
  handleClose: (accepted, email) =>
    dispatch(modalSignupActions.handleClose(accepted, email)),
  handleOpen: () => dispatch(modalSignupActions.handleOpen()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSignup);
